// Global Supply Chain page Indonesian translations

export default {
  pageTitle: "Rantai Pasokan Global",
  breadcrumbHome: "Beranda",
  breadcrumbServices: "Layanan",
  breadcrumbCurrent: "Rantai Pasokan Global",
  
  // Service links
  customManufacturing: "Manufaktur Kustom",
  technicalSupport: "Dukungan Teknis",
  afterSalesService: "Layanan Purnajual",
  qualityAssurance: "Jaminan Kualitas",
  researchDevelopment: "Penelitian & Pengembangan",
  globalSupplyChain: "Rantai Pasokan Global",
  
  // Main content
  title: "Rantai Pasokan Global yang Efisien",
  description1: "PT Eagle Industry Indonesia mempertahankan jaringan rantai pasokan global yang efisien dan andal untuk memastikan pengiriman produk kami yang tepat waktu kepada pelanggan di seluruh dunia. Sistem distribusi strategis kami menggabungkan kemampuan manufaktur lokal dengan keahlian logistik global untuk menyediakan layanan responsif sambil mempertahankan efisiensi biaya.",
  description2: "Rantai pasokan kami dirancang untuk meminimalkan waktu tunggu, mengurangi biaya inventaris, dan memastikan ketersediaan produk ketika dan di mana pelanggan kami membutuhkannya. Kami telah mengembangkan kemitraan yang kokoh dengan penyedia layanan logistik dan mendirikan pusat distribusi regional untuk menciptakan jaringan pasokan yang tangguh dan fleksibel yang dapat beradaptasi dengan perubahan permintaan pasar.",
  
  // Capabilities section
  capabilitiesTitle: "Kemampuan Rantai Pasokan Kami:",
  capabilities: [
    "Pusat distribusi strategis di pasar global utama",
    "Sistem manajemen inventaris canggih untuk tingkat stok optimal",
    "Berbagai opsi pengiriman termasuk layanan pengiriman ekspres",
    "Pelacakan pesan real-time dan visibilitas sepanjang proses pengiriman",
    "Keahlian bea cukai untuk pengiriman internasional",
    "Solusi kemasan fleksibel untuk melindungi produk selama transit",
    "Kemampuan pengiriman darurat untuk persyaratan kritis"
  ],
  
  // Regional distribution section
  distributionTitle: "Jaringan Distribusi Regional:",
  distributionDescription: "Kehadiran global kami diperkuat oleh pusat distribusi regional yang terletak strategis untuk melayani pasar industri utama. Fasilitas ini mempertahankan inventaris komprehensif produk standar dan dapat dengan cepat merakit pesanan kustom, secara signifikan mengurangi waktu pengiriman sambil memastikan kualitas produk dipertahankan sepanjang rantai pasokan.",
  
  // Metrics
  deliveryPerformance: "Kinerja Pengiriman",
  deliveryPerformanceDesc: "Tingkat pengiriman tepat waktu melampaui 98% secara global",
  globalReach: "Jangkauan Global",
  globalReachDesc: "Jaringan distribusi mencakup lebih dari 50 negara",
  inventoryManagement: "Manajemen Inventaris",
  inventoryManagementDesc: "Sistem canggih memastikan ketersediaan stok optimal",
  logisticsPartners: "Mitra Logistik",
  logisticsPartnersDesc: "Kemitraan strategis dengan pengangkut global terkemuka",
  
  // Technology section
  technologyTitle: "Teknologi Rantai Pasokan:",
  technologyDescription: "Kami memanfaatkan teknologi manajemen rantai pasokan canggih untuk mengoptimasi operasi kami dan menyediakan visibilitas kepada pelanggan kami. Sistem kami mencakup manajemen inventaris otomatis, peramalan permintaan, optimasi rute, dan kemampuan pelacakan real-time. Teknologi ini memungkinkan kami untuk merespons dengan cepat terhadap persyaratan yang berubah dan menyediakan informasi pengiriman yang akurat.",
  
  // Sustainable logistics section
  sustainableTitle: "Logistik Berkelanjutan:",
  sustainableDescription: "Rantai pasokan global kami menggabungkan inisiatif berkelanjutan untuk meminimalkan dampak lingkungan sambil mempertahankan efisiensi layanan. Kami mengoptimasi rute pengiriman untuk mengurangi emisi karbon, memanfaatkan material kemasan yang ramah lingkungan, dan bekerja dengan mitra logistik yang berbagi komitmen kami terhadap tanggung jawab lingkungan.",
  
  // Customer integration section
  customerIntegrationTitle: "Integrasi Rantai Pasokan Pelanggan:",
  customerIntegrationDescription: "Kami menawarkan solusi rantai pasokan terintegrasi yang sejalan dengan sistem pengadaan dan inventaris pelanggan kami. Melalui pertukaran data elektronik, program inventaris yang dikelola oleh penyedia, dan jadwal pengiriman yang disesuaikan, kami membantu pelanggan kami mengoptimasi operasi rantai pasokan mereka sendiri sambil memastikan ketersediaan produk yang andal.",
  
  // CTA button
  inquireDelivery: "Tanyakan Tentang Opsi Pengiriman",
  
  // Related services section
  relatedServicesTitle: "Layanan Terkait",
  relatedServicesDescription: "Jelajahi layanan komprehensif lainnya",
  afterSalesServiceDesc: "Dukungan purnajual komprehensif untuk memastikan kepuasan pelanggan.",
  customManufacturingDesc: "Solusi manufaktur yang disesuaikan untuk memenuhi persyaratan pelanggan spesifik.",
  technicalSupportDesc: "Bantuan teknis ahli untuk memastikan kinerja produk optimal.",
  readMore: "Baca selengkapnya"
};